import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";
import vueJquery from "vue-jquery";

Vue.use(Vuex);
Vue.use(vueJquery);

import sectionsModule from "./sections/sections.module";
import productsModule from "./products/products.module";
import suppliersModule from "./suppliers/suppliers.module";
import formsModule from "./forms/forms.module";
import widgetsModule from "./widgets/widgets.module";
import iframeModule from "./iframe/iframe.module";
import translateModule from "./translate/translate.module";
import usersModule from "./users/users.module";

export default new Vuex.Store({
  modules: {
    sections: sectionsModule,
    products: productsModule,
    suppliers: suppliersModule,
    forms: formsModule,
    widgets: widgetsModule,
    iframe: iframeModule,
    translate: translateModule,
    users: usersModule
  }
  // plugins: [createPersistedState()]
});
